import { render, staticRenderFns } from "./IconCaretDown.vue?vue&type=template&id=0b838de8"
import script from "./IconCaretDown.vue?vue&type=script&lang=js"
export * from "./IconCaretDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports